import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const SubjectFormFields = ({ subjectData, setSubjectData, exams, generateCode,
    codeManuallyEdited,
    setCodeManuallyEdited }) => {

    // 🚨 Null check: if subjectData is null, don't render anything
    if (!subjectData) return null;

    return (
        <>
            <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="exam-select-label">Select Exam</InputLabel>
                <Select
                    labelId="exam-select-label"
                    value={subjectData.exam_id}
                    label="Select Exam"
                    onChange={(e) => setSubjectData({ ...subjectData, exam_id: e.target.value })}
                >
                    {exams.map((exam) => (
                        <MenuItem key={exam.id} value={exam.id}>
                            {exam.title}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                fullWidth
                label="Subject Name"
                margin="dense"
                value={subjectData.name}
                onChange={(e) => {
                    const updatedName = e.target.value;
                    setSubjectData((prev) => ({
                        ...prev,
                        name: updatedName,
                        code: !prev.code || !codeManuallyEdited ? generateCode(updatedName, exams, prev.code) : prev.code
                    }));
                }}
            />
            <TextField
                fullWidth
                label="Code"
                margin="dense"
                value={subjectData.code}
                onChange={(e) => {
                    const newCode = e.target.value;
                    setSubjectData((prev) => ({
                        ...prev,
                        code: newCode
                    }));
                    if (typeof setCodeManuallyEdited === 'function') {
                        setCodeManuallyEdited(true);
                    }
                }}
            />

            <TextField
                select
                fullWidth
                label="Status"
                margin="dense"
                value={subjectData.status}
                onChange={(e) => setSubjectData({ ...subjectData, status: e.target.value })}
            >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>
        </>
    );
};

export default SubjectFormFields;
